import { Tooltip, ActionIcon } from '@mantine/core'
import { ArrowRight } from 'lucide-react'

import { navigate, routes } from '@redwoodjs/router'

import Button from 'src/components/Buttons/Button/Button'
import IconAlertCircle from 'src/icons/IconAlertCircle'

const namesMatch = (
  driverName: string,
  firstName: string,
  lastName: string
) => {
  const normalizedDriverName = driverName?.toLowerCase().trim()
  const normalizedApplicantName = `${firstName} ${lastName}`
    .toLowerCase()
    .trim()
  return normalizedDriverName === normalizedApplicantName
}

const VoEDetailsHeader = ({
  showSubmitButton,
  loadingSubmit,
  voe,
  submitButtonText = 'Submit',
  title = 'Incoming VoE Request',
  showNameMismatchCheck = true,
  showDeclineButton = false,
  onDecline,
  loadingDecline = false,
}) => {
  const showNameMismatch =
    showNameMismatchCheck &&
    voe?.driverName &&
    voe?.applicant &&
    !namesMatch(voe.driverName, voe.applicant.firstName, voe.applicant.lastName)

  return (
    <div className="flex w-full flex-row">
      <div className="flex flex-1 flex-col gap-1">
        <div className="text-lg font-semibold text-doubleNickel-gray-900">
          {title}
        </div>
        <div className="flex flex-row items-center gap-2 text-sm">
          <span className="font-medium text-doubleNickel-gray-900">
            {voe?.driverName || (voe?.applicant ? `${voe.applicant.firstName} ${voe.applicant.lastName}` : 'N/A')}
          </span>
          {voe?.applicant && (
            <Tooltip label="Go to profile">
              <ActionIcon
                variant="subtle"
                size="sm"
                onClick={(event) => {
                  event.stopPropagation()
                  navigate(
                    routes.applicantDetails({
                      id: voe.applicant.applicantId,
                      tab: 'application',
                    })
                  )
                }}
              >
                <ArrowRight
                  size={16}
                  className="stroke-doubleNickel-brand-500"
                />
              </ActionIcon>
            </Tooltip>
          )}
        </div>
        {showNameMismatch && (
          <div className="flex items-center gap-1.5 rounded-md bg-doubleNickel-warning-50 px-2 py-1.5 border border-doubleNickel-warning-200 w-fit">
            <IconAlertCircle
              className="h-3.5 w-3.5 shrink-0 stroke-doubleNickel-warning-600"
              stroke="currentColor"
              fill="none"
            />
            <span className="text-xs text-doubleNickel-warning-700">
              <span className="font-medium">Name mismatch:</span> Matches applicant &ldquo;{voe.applicant.firstName}{' '}
              {voe.applicant.lastName}&rdquo;
            </span>
          </div>
        )}
      </div>
      {(showSubmitButton || showDeclineButton) && (
        <div className="flex flex-row gap-3">
          {showDeclineButton && (
            <Button
              loading={loadingDecline}
              onClick={onDecline}
              text="Decline"
              variant="outline"
              color="red"
            />
          )}
          {showSubmitButton && (
            <Button
              loading={loadingSubmit}
              type="submit"
              text={submitButtonText}
            />
          )}
        </div>
      )}
    </div>
  )
}

export default VoEDetailsHeader
